import React, { useState } from 'react'
import CommonFilter from '@/components/common/CommonFilter'
import CommonTable, { type TableColumn } from '@/components/common/CommonTable'
import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import type { IPageInfo } from '@/interface/common.interface'
import TablePagination from '@/components/common/TablePagination'

const Company: React.FC = () => {
    const navigate = useNavigate()
    const columns: TableColumn<any>[] = [
        {
            key: "name",
            header: "Name",
        },
        {
            key: "type",
            header: "Type",
        },
        {
            key: "searchedLocation",
            header: "Searched Location",
        },
        {
            key: "address",
            header: "Address",
        },
        {
            key: "location",
            header: "Location",
        },
        {
            key: "range",
            header: "Range",
        },
        {
            key: "status",
            header: "Status",
        },
        {
            key: "isPunchAllowed",
            header: "Is Punch Allowed",
        },
        {
            key: "branchId",
            header: "Branch ID",
        },
    ];

    const rawData = [
        {
            name: "Main Site",
            type: "office",
            searchedLocation: "Indore, MP",
            address: "123 Business Park",
            location: "Indore, MP",
            range: "100",
            status: 'Active',
            isPunchAllowed: '--',
            branchId: "1221"
        }
    ];

    const [paginationData, setPaginationData] = useState<IPageInfo>({
        pageSize: 10,
        currentPage: 1,
        total: rawData.length,
        totalPages: Math.ceil(rawData.length / 10) || 1,
    });

    const handleChangePageSize = (value: number) => {
        setPaginationData((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1,
            totalPages: Math.ceil(prev.total / value) || 1,
        }));
    };

    const startIndex = (paginationData.currentPage - 1) * paginationData.pageSize;
    const paginatedData = rawData.slice(startIndex, startIndex + paginationData.pageSize);

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title='Company'
                    buttonText='Add Company'
                    buttonIcon={<Plus />}
                    onClick={() => { navigate('/super-admin/create-company') }}
                />
                <CommonFilter />
                <CommonTable columns={columns} data={paginatedData} />
                <TablePagination
                    paginationData={paginationData}
                    setPaginationData={setPaginationData}
                    handleChangePageSize={handleChangePageSize}
                />
            </div>
        </Layout>
    )
}

export default Company